import { faChevronDown, faSignOutAlt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useRouter } from 'found';
import React, { useState } from 'react';
import { createFragmentContainer, graphql } from 'react-relay';
import styled from 'styled-components';
import Spacer from '../Spacer';
import { UserDropdown_user } from './__generated__/UserDropdown_user.graphql';
import { routes } from '../../routes';

const Container = styled.div`
  position: relative;
`;

const Dropdown = styled.div`
  box-shadow: 0 0 20px #00000021;
  padding: 10px 0px;
  margin-top: 6px;
  border-radius: 6px;
  width: 258px;
  right: 0px;
  background: white;
  position: absolute;
  z-index: 11;
  overflow: hidden;
`;

const DropdownContent = styled.div`
  position: relative;
`;

const BackgroundHider = styled.div`
  position: fixed;
  width: 100%;
  height: 100%;
  z-index: 10;
  top: 0;
  left: 0;
`;

const CurrentItem = styled.div<{ dropped: boolean }>`
  border-radius: 30px;
  padding: 8px 11px;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: all 0.3s;
  cursor: pointer;
  &:hover {
    background: #ffffff12;
  }
  ${(props) =>
    props.dropped
      ? `
      box-shadow: 0 0 20px #00000012;
      background: #dcdcdc14;
  `
      : `
    &:hover {
      background: #ffffff12;
    }
  `}
`;

const Content = styled.div`
  display: flex;
  align-items: center;
`;

const AccountContainer = styled.div`
  display: flex;
  padding: 13px 24px;
  border-radius: 0px;
  cursor: pointer;
  transition: all 0.1s;
  align-items: center;
  &:hover {
    background: #f7f7f9;
  }
`;

const UserImage = styled.div<{ url: string }>`
  background-image: url(${(props) => props.url});
  background-size: cover;
  background-position: center;
  width: 30px;
  height: 30px;
  border-radius: 100%;
`;

const UserIcon = styled.div<{ url: string }>`
  background-image: url(${(props) => props.url});
  background-size: cover;
  background-position: center;
  width: 25px;
  height: 25px;
  border-radius: 100%;
`;

const UserInfo = styled.div``;

const UserName = styled.div`
  font-size: 16px;
  font-weight: 700;
`;

const Subheading = styled.div`
  color: #9092c1;
  font-size: 13px;
`;

const MenuItem = styled.div`
  font-size: 14px;
  font-weight: 500;
  display: flex;
  padding: 13px 24px;
  border-radius: 0px;
  cursor: pointer;
  transition: all 0.1s;
  align-items: center;
  &:hover {
    background: #f7f7f9;
  }
`;

const Version = styled.div`
  text-align: center;
  font-size: 12px;
  color: #9092c1;
`;

type Props = {
  user: UserDropdown_user;
  className?: string;
};

function AccountSelector({ user, className }: Props) {
  const [dropped, setDropped] = useState(false);
  const { router } = useRouter();

  return (
    <Container className={className}>
      {dropped && <BackgroundHider onClick={() => setDropped(false)} />}
      <CurrentItem
        onClick={() => {
          setDropped(!dropped);
        }}
        dropped={dropped}
      >
        <Content>
          <UserIcon url={user.profileURL} />
          <Spacer horizontal spacing={1} />
          <FontAwesomeIcon icon={faChevronDown} color='#DEE1FF' />
        </Content>
      </CurrentItem>

      {dropped && (
        <Dropdown>
          <DropdownContent>
            <AccountContainer
              onClick={() => {
                setDropped(!dropped);
                router.push(routes.userProfile);
              }}
            >
              <UserImage url={user.profileURL} />
              <Spacer horizontal spacing={2} />
              <UserInfo>
                <UserName>
                  {user.firstName} {user.lastName}
                </UserName>
                <Subheading>My Account</Subheading>
              </UserInfo>
            </AccountContainer>
            <MenuItem
              onClick={() => {
                setDropped(!dropped);
                router.push('/logout');
              }}
            >
              <FontAwesomeIcon icon={faSignOutAlt} color='#9092C1' />
              <Spacer horizontal spacing={2} />
              Log out
            </MenuItem>
            <Spacer vertical spacing={1} />
            <Version>PayPI 2021 v1.1</Version>
            <Spacer vertical spacing={1} />
          </DropdownContent>
        </Dropdown>
      )}
    </Container>
  );
}

export default createFragmentContainer(AccountSelector, {
  user: graphql`
    fragment UserDropdown_user on User {
      firstName
      lastName
      profileURL
    }
  `,
});
